import { render, staticRenderFns } from "./FileModalOwner.vue?vue&type=template&id=aeb4e652&scoped=true"
import script from "./FileModalOwner.vue?vue&type=script&lang=js"
export * from "./FileModalOwner.vue?vue&type=script&lang=js"
import style0 from "./FileModalOwner.vue?vue&type=style&index=0&id=aeb4e652&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb4e652",
  null
  
)

export default component.exports